import React from "react";
//material ui
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Skeleton from "@material-ui/lab/Skeleton";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
//router
import { useHistory } from "react-router";
//style
import useStyles from "./style/style";
//contect
import { useCollectionDataOnce } from "react-firebase-hooks/firestore";
import { bannerCollection } from "../../../components/firebase/DataProvider";

function Banner() {
  const classes = useStyles();

  const history = useHistory();

  const [banners, loading] = useCollectionDataOnce(bannerCollection, {
    idField: "id",
  });

  const handleAction = (item) => async () => {
    // console.log(item.target_type);
    switch (item.target_type) {
      case "kategori1":
      case "kategori2":
      case "kategori3":
      case "brand":
        history.push(
          `/kategori/${item.target_type}/${item.target_nama}/${item.target_id}`
        );
        break;
      case "promo":
        break;
      case "produk":
        history.push("/productDetail", {
          id: item.target_id,
          loaded: false,
        });
        break;
      case "webview":
        window.open(`${item.target_id}`);
        break;
      default:
        break;
    }
  };

  return (
    <Grid container className={classes.rootBanner} spacing={2}>
      <Grid item xs={12} nowrap>
          <Typography
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            Ni, katalog-nya!
          </Typography>
      </Grid>
      {banners?.length > 0 &&
        banners?.map((item, index) => {
          return (
            <Grid item xs={6} sm={6} md={6} lg={6} key={index}>
              <Card onClick={handleAction(item)}>
                <CardActionArea>
                  {loading ? (
                    <Skeleton variant="rect" height={260} />
                  ) : (
                    <CardMedia
                      image={item.url}
                      className={classes.banner}
                      alt="banners"
                    />
                    // <img
                    //   className={classes.banner}
                    //   src={item.url}
                    //   alt="banners"
                    // />
                  )}
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
    </Grid>
  );
}

export default Banner;
